<template>
  <div>
    <div class="clear"></div>

    <section id="content" style="max-width: 1150px; margin-left: auto; margin-right: auto;">
      <div class="content-wrap">
        <div class="padding-responsive">
          <div class="row" style="margin-top: 50px;">
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left;">
              <h3 class="the-title-font" >{{cateEN}}</h3>
            </div>
            <div class="col-lg-10 col-md-10 col-10" style="text-align:left; ">
              <!-- <h3
                style="font-size: 24px; font-family:'supermarket'; color: #bcbcbd; margin-bottom: 0;"
              >{{webcat}}</h3>-->
            </div>
          </div>
          <!-- Shop Item 1
          =============================================-->
          <div class="row">
            <div
              class="col-lg-3 col-md-6 col-6"
              v-for="(item,ind) in items"
              :key="ind"
              style="padding-bottom: 20px;padding-left:5px !important; padding-right:5px !important;"
            >
              <div class="product iproduct clearfix imagefocus" style="border: 1px solid #f0f0f0; ">
                <!-- <div img> -->
                <div class="product-image" style="height: 300px; ">
                  <img
                    @click="moveTo(item.productGroupId)"
                    style="width:85%; margin: 10px auto; height:auto; cursor:pointer;"
                    :src="getProductPath(item.mainImage)"
                    alt="Image 1"
                  />
                </div>
                <!-- <div img> -->

                <!-- product-desc center -->
                <div class="product-desc center">
                  <!-- <div class="product-title"><h3><a href="#">{{ item.name }}</a></h3></div> -->
                  <input type="hidden" name="wproduct" :value="getProductID(item.productItemId)" />
                  <input
                    type="submit"
                    :value="getProductName(item.name)"
                    style="    border: 0; font-family:'mitr-regular' !important;
										background-color: white;"
                  />
                  <!-- product-price -->
                  <div class="product-price">
                    <ins>{{ formatPrice(item.rentalPrice) }} บาท</ins>
                  </div>
                  <!-- product-price -->
                </div>
                <!-- product-desc center -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
// import store from "@/store.js";
import axios from "axios";
import store from '@/store'

export default {
  mixins: [myMixins],
  data() {
    return {
      webcat: "",
      cateEN: "",
      itemInfo: "",
      original: [],
      items: []
    };
  },
  created() {
    this.webcat = decodeURI(this.$route.params.searchtext);
    this.setCatEN();
  },
  watch: {
    async webcat(newvalue) {
      await this.getProducts(newvalue);
    },
    $route(to) {
      this.webcat = to.params.searchtext;
      this.setCatEN(this.webcat);
    }
  },
  async mounted() {
    await this.getProducts(this.webcat);
  },
  methods: {
    setCatEN() {
      this.cateEN = "Searching : " + this.webcat;
    },
    async getProducts(wc) {
        var api_url = store.state.apiUrl + "/web-api/web/grouplist" ;

        var response = await axios.post(api_url, {}, store.state.apiHeader);

        var all = response.data;
        if (wc === null || wc === undefined || wc === "") {
          this.items = all;
          this.original = all;
        } else {
          var fil = [];
          all.forEach(x => {
            // var arr = x.webCategory.split("|");
            if (x.name.toLowerCase().includes(wc.toLowerCase())) {
              fil.push(x);
            }
          });
          this.items = fil;
          this.original = fil;

          // this.items = all.filter(f => f.webCategory === wc);
          // this.original = all.filter(f => f.webCategory === wc);
        }
    },

   
    getProductID(productid) {
      return productid;
    },
    getProductName(productname) {
      return productname;
    }
  },
  components: {}
};
</script>
 
<style >

.title-font{
  font-size: 2.5rem;
}

.padding-responsive{
  margin-left : 56px ; margin-right : 56px ;
}
.container {
  width: 1200px;
}
.product-desc {
  padding: 0 !important;
}
.product-desc {
 font-size: 42px; margin-bottom: 0; color:#777;
}

.padding-responsive{
  margin-left : 56px ; margin-right : 56px ;
}


@media only screen and (max-width: 800px) {

  .title-font{
  font-size: 1.9rem;
}

  .product-image {
    height: 170px !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }

  .padding-responsive{
  margin-left : 0 ; margin-right : 0 ;
  }

  .product-price{
    font-size: 0.9rem !important;
  }
  .product-desc{
    font-size: 0.9rem !important;
    font-family: "mitr-regular" !important;
    padding-left: 0 !important;
  }
   .product-image {
    height: 170px !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }
}

/* New rules if the window width is smaller than 1024px */
@media only screen and (max-width: 578px) {
  .product-image {
    height: 170px !important;
  }
  .product,
  .iproduct {
    height: 270px !important;
  }
  .swiper_wrapper {
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    height: 270px !important;
  }
  .swiper-slide {
    width: 100% !important;
    height: auto !important;
  }
}
</style>